// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wt-main-column > .container {
  width: auto;
}

.wt-app-shell {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 50px);
  min-height: calc(100dvh - 50px);
}

.wt-app-main {
  flex: 1 0 auto;
  width: 100%;
}

.wt-app-shell > .footer {
  flex: 0 0 auto;
}

.wt-entry-actions-menu {
  z-index: 1060;
  right: auto !important;
  bottom: auto !important;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.wt-standard-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.wt-standard-footer-inner .links,
.wt-standard-footer-inner .copyright {
  flex: 0 0 auto;
}

.wt-login-container {
  padding-bottom: 40px;
}

.wt-login-page {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.wt-login-header {
  margin: 34px 0 18px;
}

.wt-login-header h1 {
  margin: 0;
  font-size: 38px;
  letter-spacing: -0.8px;
}

.wt-login-flow-notice {
  margin: 0 0 16px;
  padding: 14px 16px;
  border-left-width: 3px;
}

.wt-login-flow-notice h2 {
  margin: 0 0 6px;
  font-size: 18px;
  letter-spacing: -0.2px;
}

.wt-login-flow-notice p {
  margin-bottom: 6px;
}

.wt-login-flow-notice p:last-child {
  margin-bottom: 0;
}

.wt-login-flow-continuation {
  color: #245269;
  font-weight: 600;
}

.wt-login-session-option {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 14px;
  padding: 0 2px;
}

.wt-login-session-option label {
  margin: 0;
  font-weight: 500;
}

.wt-login-session-option span {
  color: #777;
  font-size: 13px;
  white-space: nowrap;
}

.wt-auth-options-loading {
  margin: 28px 0;
  text-align: center;
}

.wt-email-auth-panel {
  margin-bottom: 12px;
}

.wt-email-auth-panel .panel-body {
  padding: 18px 20px 20px;
}

.wt-email-auth-panel .panel-body > .text-muted:first-child {
  margin-bottom: 16px;
}

.wt-passkey-option {
  margin: 12px 0;
}

.wt-passkey-option .help-block {
  margin-bottom: 0;
}

.wt-password-toggle {
  margin: 8px 0;
  padding: 10px 12px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 0;
}

.wt-password-signin-panel {
  padding: 14px 0 4px;
}

.wt-login-help-links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 12px 0 0;
}

.wt-login-help-links .btn-link {
  padding: 0;
}

.wt-recovery-signin-panel {
  margin: 14px 0 0;
}

.wt-social-signin-section {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #e5e5e5;
}

.wt-social-signin-section .btn-group {
  display: flex;
  flex-wrap: wrap;
}

.wt-social-signin-section .btn {
  flex: 1 0 auto;
}

.wt-login-utilities {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #e5e5e5;
  color: #666;
  text-align: center;
}

.wt-access-message {
  max-width: 540px;
  margin: 32px auto;
  text-align: center;
}

.wt-access-message .panel-body {
  padding: 28px 24px;
}

.wt-access-message h2 {
  margin: 8px 0 10px;
  font-size: 26px;
}

.wt-access-message p {
  margin-bottom: 18px;
}

.wt-access-message-icon {
  color: #8a6d3b;
  font-size: 28px;
}

.wt-auth-prompt-modal .modal-dialog {
  margin-top: 80px;
}

.wt-auth-prompt-modal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 8px;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.28);
}

.wt-auth-prompt-modal .modal-header {
  padding: 20px 20px 12px;
  border-bottom: 0;
}

.wt-auth-prompt-modal .modal-title {
  padding-right: 28px;
  color: #245269;
  font-size: 22px;
  font-weight: 600;
}

.wt-auth-prompt-modal .modal-body {
  padding: 4px 20px 10px;
  font-size: 16px;
  line-height: 1.5;
}

.wt-auth-prompt-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px 20px;
  border-top: 0;
}

.wt-auth-prompt-modal .modal-footer::before,
.wt-auth-prompt-modal .modal-footer::after {
  display: none;
}

.wt-auth-prompt-copy p:last-child {
  margin-bottom: 0;
}

.wt-context-sidebar {
  position: sticky;
  top: 84px;
  padding: 0 0 24px;
}

.list-group-item.wt-entry-row,
.list-group.wt-list > .list-group-item.wt-entry-row,
.wt-list .list-group > .list-group-item.wt-entry-row {
  display: grid;
  grid-template-columns: var(--wt-entry-row-icon-column) minmax(0, 1fr);
  align-items: start;
  column-gap: var(--wt-entry-row-column-gap);
  padding-block: var(--wt-entry-row-padding-block);
  padding-inline: var(--wt-entry-row-padding-inline-start) var(--wt-entry-row-padding-inline-end);
  background-color: transparent;
}

.list-group-item.wt-entry-row > .wt-entry-row-icon {
  position: static;
  display: inline-flex;
  grid-column: 1;
  align-items: center;
  justify-content: center;
  width: var(--wt-entry-row-icon-column);
  min-width: 0;
  margin: 2px 0 0;
  font-size: 20px;
  line-height: 1;
}

.list-group-item.wt-entry-row > .wt-entry-row-main,
.list-group.wt-list > .list-group-item.wt-entry-row > .wt-entry-row-main,
.wt-list .list-group > .list-group-item.wt-entry-row > .wt-entry-row-main {
  grid-column: 2;
  float: none;
  min-width: 0;
  width: auto;
  margin-left: 0;
}

.wt-entry-row-title > .label,
.wt-entry-row-title > a + .label {
  margin-left: 6px;
  vertical-align: 2px;
}

.wt-entry-row-title > .wt-screening-status {
  display: inline-block;
  margin-left: 6px;
  color: #4cae4c;
  font-size: 14px;
  line-height: 1;
  vertical-align: 1px;
}

.wt-entry-row-subtitle {
  margin-bottom: 2px;
  color: #777;
  font-size: 12px;
}

.wt-entry-row-content {
  max-width: 760px;
  color: #4d4d4d;
  line-height: 1.45;
}

.wt-entry-row-show-more,
.wt-entry-child-count {
  min-height: 0;
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  line-height: inherit;
  vertical-align: baseline;
}

.wt-entry-row-show-more {
  margin-left: 5px;
}

.wt-entry-child-count {
  color: inherit;
}

.wt-entry-row-footer > .entry-options {
  float: none !important;
  margin: 0;
}

.wt-entry-row-footer > .entry-options > a {
  display: inline-flex;
  align-items: center;
}

.wt-entry-children {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px 18px;
  margin-top: 10px;
  padding: 10px 12px;
  background: var(--wt-surface-muted);
  border: 1px solid var(--wt-border);
  border-radius: 4px;
}

.wt-entry-children-group h4 {
  margin: 0 0 5px;
  color: var(--wt-text);
  font-size: 13px;
  font-weight: 600;
}

.wt-entry-children-group ul,
.wt-entry-children-group li:last-child {
  margin-bottom: 0;
}

.wt-entry-children-group li {
  margin-bottom: 3px;
}

.wt-entry-children-message {
  margin-top: 8px;
  padding: 8px 10px;
  background: var(--wt-surface-muted);
  border-radius: 4px;
}

.wt-entry-row-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 12px;
  margin-top: 5px;
  font-size: 12px;
}

.wt-entry-row-footer > a,
.wt-entry-row-footer > span {
  margin-right: 0 !important;
  color: #777;
}

.wt-entry-row-media {
  margin: 8px 0 5px;
}

.wt-entry-row-media .img-responsive {
  max-width: 220px;
  max-height: 220px;
  border-radius: 2px;
}

.wt-deterministic-avatar {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.75);
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.22);
  color: #fff;
  font-weight: 700;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);
}

.wt-profile-avatar {
  margin-bottom: 8px;
  font-size: 28px;
}

.navbar-nav > li > .wt-navbar-control {
  display: block;
  padding: 15px;
  margin: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #777;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: 20px;
  -webkit-appearance: none;
  appearance: none;
}

.navbar-nav > li > .wt-navbar-control:hover,
.navbar-nav > li > .wt-navbar-control:focus {
  color: #333;
  text-decoration: none;
}

.wt-user-menu-choice {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  gap: 8px;
  width: 100%;
  padding: 6px 20px;
  color: var(--wt-text, #333);
  text-align: left;
  white-space: normal;
}

.wt-user-menu-choice:hover,
.wt-user-menu-choice:focus {
  color: var(--wt-text, #333);
}

.wt-user-menu-choice > i {
  margin-top: 3px;
  color: var(--wt-text-muted, #777);
}

.wt-user-menu-choice strong,
.wt-user-menu-choice small {
  display: block;
}

.wt-user-menu-choice strong {
  color: var(--wt-text, #333);
}

.wt-user-menu-choice small {
  margin-top: 1px;
  color: var(--wt-text-muted, #777);
  font-size: 11px;
  line-height: 1.3;
}

.wt-content-view-summary {
  min-height: 24px;
  margin-bottom: 5px;
  font-size: 12px;
}

.wt-content-view-summary .btn-link {
  padding: 1px 0;
}

/* Keep keyboard location unmistakable without adding a ring to pointer clicks. */
a:focus-visible,
button:focus-visible,
[role='button']:focus-visible,
.btn:focus-visible,
.btn-link:focus-visible,
.nav > li > a:focus-visible {
  outline: 3px solid #0b6b9c !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 2px #fff !important;
}

.wt-context-sidebar .wt-nav.nav {
  margin: 0;
  padding: 6px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
}

.wt-context-sidebar .wt-nav .dropdown-header {
  padding: 8px 12px;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.wt-context-sidebar .wt-nav > li > a {
  display: block;
  padding: 6px 12px;
}

.wt-context-sidebar .wt-nav > li > a.wt-context-sidebar-link {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr) auto;
  align-items: start;
  column-gap: 8px;
  min-height: 36px;
  padding: 7px 12px;
}

.wt-context-sidebar .wt-context-sidebar-link > i,
.wt-context-sidebar .wt-context-sidebar-link > img {
  margin: 2px 0 0;
  text-align: center;
}

.wt-context-sidebar .wt-context-sidebar-label {
  min-width: 0;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.wt-context-sidebar .wt-context-sidebar-badge {
  align-self: start;
  justify-self: end;
  min-width: 26px;
  margin: 0 0 0 10px;
  padding: 4px 6px;
  border: 1px solid #cbd6e0;
  border-radius: 5px;
  color: #46596c;
  background: #e8eef4;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
}

.wt-popover {
  position: relative;
  display: inline-flex;
  cursor: pointer;
}

.wt-popover .wt-popover-content {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 20;
  display: none;
  min-width: 180px;
  margin-top: 8px;
  padding: 8px 10px;
  border: 1px solid var(--wt-border);
  border-radius: 4px;
  background: var(--wt-surface);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.15);
}

.wt-popover:hover .wt-popover-content,
.wt-popover:focus-within .wt-popover-content {
  display: block;
}

.vis-container {
  position: relative;
}

.vis-container.fullscreen {
  z-index: 10000;
  position: fixed;
  inset: 0;
  padding: 12px;
  background: rgba(255, 255, 255, 0.98);
  overflow: auto;
}

.wt-viz-btn-cont {
  position: absolute;
  z-index: 100;
}

.wt-viz-btn-cont .wt-viz-btn {
  background-color: #00b0b9;
  padding: 3px 5px;
  border-radius: 3px;
  margin: 5px;
  display: inline-block;
}

.wt-viz-btn-cont .wt-viz-btn .btn.btn-link {
  padding: 0;
}

.page-header.wt-header.wt-profile-header {
  background-image: linear-gradient(-110deg, #48227d 0%, #2f569c 100%);
  color: #fff;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* Tighten entry-page spacing between geo-pattern bar and main header. */
.wt-geo-pattern + .page-header.wt-header:not(.wt-profile-header) {
  margin-top: 16px;
}

@media (max-width: 991px) {
  .wt-entry-header .pull-left,
  .wt-entry-header .pull-right {
    float: none !important;
    display: block;
  }
}

@media (max-width: 767px) {
  body {
    padding-top: 50px;
  }

  .wt-primary-navigation .wt-header-more-menu {
    position: fixed;
    top: 50px;
    right: 8px;
    left: auto;
    width: min(280px, calc(100vw - 24px));
    max-height: calc(100vh - 58px);
    max-height: calc(100dvh - 58px);
    overflow-y: auto;
  }

  .breadcrumb.wt-bc {
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    overflow-x: visible;
    white-space: normal;
  }

  .breadcrumb.wt-bc > li {
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .wt-access-message {
    margin: 20px 5px;
  }

  .wt-login-flow-notice {
    padding: 13px 14px;
  }

  .wt-login-container {
    padding-right: 20px;
    padding-left: 20px;
  }

  .wt-login-header {
    margin-top: 28px;
  }

  .wt-login-header h1 {
    font-size: 34px;
  }

  .wt-login-session-option {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }

  .wt-login-session-option span {
    padding-left: 20px;
  }

  .wt-email-auth-panel .panel-body {
    padding: 16px;
  }

  .wt-login-page .btn-block {
    min-height: 44px;
  }

  .wt-auth-prompt-modal .modal-dialog {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto;
    margin: 0;
    transform: none !important;
  }

  .wt-auth-prompt-modal .modal-content {
    padding-bottom: env(safe-area-inset-bottom);
    border-radius: 14px 14px 0 0;
  }

  .wt-auth-prompt-modal .modal-header {
    padding-top: 22px;
  }

  .wt-auth-prompt-modal .modal-footer {
    padding-bottom: 18px;
  }

  .wt-auth-prompt-modal .modal-footer .btn {
    min-height: 44px;
  }

}

/* Match the legacy xxs utility: retain the wordmark on larger phones/tablets. */
@media (max-width: 479px) {
  .navbar-brand-label .hidden-xxs {
    display: none !important;
  }

  .footer .copyright {
    display: block;
    float: none !important;
    margin-top: 0;
    text-align: center;
  }

  .footer .links {
    text-align: center;
  }

  .wt-standard-footer-inner {
    flex-direction: column;
    justify-content: center;
    gap: 12px;
    padding-top: 14px;
    padding-bottom: 14px;
  }
}

.wt-explore-page-header {
  position: relative;
}

.wt-explore-page #browse {
  scroll-margin-top: 70px;
}

.wt-explore-header-actions {
  padding: 8px 0;
  font-size: 28px;
  line-height: 1;
}

.wt-explore-header-actions > a {
  color: #767676;
  text-decoration: none;
}

.wt-explore-header-actions > a + a {
  margin-left: 15px;
}

.wt-explore-filter-toggle {
  margin-bottom: 10px;
}

.wt-explore-filter-toggle .badge {
  margin-left: 6px;
}

.wt-explore-page .media.wt-category .media-body > div span,
.wt-explore-page .media.wt-category .media-body > div a {
  color: var(--wt-text-muted);
}

.wt-explore-page .wt-category-icon {
  border: 1px solid var(--wt-border);
}

.wt-explore-page .media.wt-category .media-body > div a.wt-category-all-link {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  margin-top: 2px;
  color: var(--wt-brand-primary);
  font-weight: 600;
  gap: 4px;
}

.wt-explore-controls {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-bottom: 15px;
}

.wt-explore-controls .btn-group {
  margin-bottom: 0;
}

.wt-explore-page .nav.nav-tabs.wt-tabs {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  align-items: stretch;
  gap: 4px;
  margin-right: 0;
  margin-left: 0;
  padding: 4px;
  border: 1px solid var(--wt-border);
  border-radius: 4px;
  background-color: var(--wt-surface-muted);
  scrollbar-width: thin;
}

.wt-explore-page .nav.nav-tabs.wt-tabs::before,
.wt-explore-page .nav.nav-tabs.wt-tabs::after {
  display: none;
}

.wt-explore-page .nav.nav-tabs.wt-tabs > li {
  float: none;
  flex: 0 0 auto;
  width: auto;
}

.wt-explore-page .nav.nav-tabs.wt-tabs > li > a,
.wt-explore-page .nav.nav-tabs.wt-tabs > li.active > a {
  display: flex;
  align-items: center;
  min-height: 42px;
  margin: 0;
  padding: 9px 12px;
  border-bottom: 3px solid transparent;
  color: var(--wt-text-muted);
  gap: 6px;
  white-space: nowrap;
}

.wt-explore-page .nav.nav-tabs.wt-tabs > li.active > a,
.wt-explore-page .nav.nav-tabs.wt-tabs > li.active > a:hover,
.wt-explore-page .nav.nav-tabs.wt-tabs > li.active > a:focus {
  border-bottom-color: #d26911;
  color: var(--wt-text);
  background-color: var(--wt-surface);
}

.wt-explore-results .list-group.wt-list {
  overflow: hidden;
  border-radius: 4px;
}

.wt-explore-results .list-group.wt-list .highlight {
  display: flex;
  align-items: center;
  min-height: 44px;
  margin-bottom: 5px;
  padding: 10px 14px 8px;
  border-color: var(--wt-border);
  color: var(--wt-text);
  gap: 10px;
}

.wt-explore-results .list-group.wt-list .highlight > .fa,
.wt-explore-results .list-group.wt-list .highlight > .glyphicon {
  position: static;
  flex: 0 0 auto;
  color: var(--wt-text-muted);
}

.wt-explore-results .list-group.wt-list .highlight > div {
  float: none;
  margin-left: 0;
}

.wt-explore-results .list-group.wt-list .wt-entry-row {
  margin-bottom: 0;
  border: 0;
  border-bottom: 1px solid var(--wt-border);
}

.wt-explore-results .wt-entry-row-subtitle,
.wt-explore-results .wt-entry-row-footer > a,
.wt-explore-results .wt-entry-row-footer > span {
  color: var(--wt-text-muted);
}

.wt-explore-results .wt-entry-row-footer .fa {
  color: inherit;
}

@media (max-width: 767px) {
  .wt-explore-controls {
    display: block;
  }

  .wt-explore-controls > .btn-group {
    margin-bottom: 8px;
  }

  .wt-explore-controls .wt-content-view-filter {
    display: flex;
    overflow-x: auto;
    max-width: 100%;
    scrollbar-width: none;
  }

  .wt-explore-controls .wt-content-view-filter::-webkit-scrollbar {
    display: none;
  }

  .wt-explore-controls .wt-content-view-filter > .btn {
    float: none;
    flex: 0 0 auto;
  }

  .wt-explore-advanced-filters {
    display: none;
  }

  .wt-explore-advanced-filters.is-open {
    display: block;
  }

  .wt-explore-page .nav.nav-tabs.wt-tabs {
    margin-right: 0;
    margin-left: 0;
  }
}

/* Search result keyboard navigation */
.wt-result-focused {
  background-color: #f0f6ff;
  outline: 2px solid #337ab7;
  outline-offset: -2px;
}

[data-theme='dark'] .wt-result-focused {
  background-color: #1a2a3a;
  outline-color: #5ba3d9;
}

.wt-reputation-card {
  border-top: 3px solid #2f7d68;
}

.wt-reputation-score {
  width: 92px;
  height: 92px;
  margin: 0 auto 8px;
  border: 8px solid #d9eee8;
  border-radius: 50%;
  color: #1f6655;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 34px;
  font-weight: 700;
  line-height: 76px;
}

.wt-reputation-dimension .progress {
  height: 8px;
  margin: 3px 0 10px;
  background: #edf2f0;
}

.wt-reputation-dimension .progress-bar {
  background: linear-gradient(90deg, #2f7d68, #56a37f);
}

.wt-pin-inputs {
  display: flex;
  gap: 10px;
}

.wt-pin-inputs .pincode-input-text {
  width: 55px;
  text-align: center;
}

.wt-code-wrap {
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 767px) {
  .wt-topic-selector {
    width: 100%;
  }

  .wt-topic-selector .wt-topic-selector-button {
    max-width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
    text-align: left;
  }

  .wt-outline-tree-button {
    display: inline-flex;
    max-width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
    text-align: left;
  }

  .wt-outline-tree-button .fa {
    flex: 0 0 auto;
    margin-top: 2px;
  }

  .wt-pin-inputs {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 6px;
  }

  .wt-pin-inputs .pincode-input-text {
    width: 100%;
    min-width: 0;
    padding-right: 4px;
    padding-left: 4px;
  }
}

.wt-reputation-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.wt-reputation-badges .label {
  display: inline-block;
  padding: 6px 9px;
}

.wt-entry-lifecycle-notice {
  margin-bottom: 14px;
  border-left-width: 4px;
}

.wt-entry-lifecycle-stack {
  margin: 12px 0 16px;
}

.wt-entry-lifecycle-stack .wt-entry-lifecycle-notice:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./client/src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,qEAAqE;EACrE,kBAAkB;EAClB,0CAA0C;EAC1C,gDAAgD;EAChD,+FAA+F;EAC/F,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,UAAU;EACV,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,iFAAiF;AACjF;;;;;;EAME,qCAAqC;EACrC,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oEAAoE;EACpE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,UAAU;IACV,qCAAqC;IACrC,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,2CAA2C;IAC3C,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA,gFAAgF;AAChF;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;EAGE,4BAA4B;EAC5B,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".wt-main-column > .container {\n  width: auto;\n}\n\n.wt-app-shell {\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 50px);\n  min-height: calc(100dvh - 50px);\n}\n\n.wt-app-main {\n  flex: 1 0 auto;\n  width: 100%;\n}\n\n.wt-app-shell > .footer {\n  flex: 0 0 auto;\n}\n\n.wt-entry-actions-menu {\n  z-index: 1060;\n  right: auto !important;\n  bottom: auto !important;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.wt-standard-footer-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.wt-standard-footer-inner .links,\n.wt-standard-footer-inner .copyright {\n  flex: 0 0 auto;\n}\n\n.wt-login-container {\n  padding-bottom: 40px;\n}\n\n.wt-login-page {\n  width: 100%;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.wt-login-header {\n  margin: 34px 0 18px;\n}\n\n.wt-login-header h1 {\n  margin: 0;\n  font-size: 38px;\n  letter-spacing: -0.8px;\n}\n\n.wt-login-flow-notice {\n  margin: 0 0 16px;\n  padding: 14px 16px;\n  border-left-width: 3px;\n}\n\n.wt-login-flow-notice h2 {\n  margin: 0 0 6px;\n  font-size: 18px;\n  letter-spacing: -0.2px;\n}\n\n.wt-login-flow-notice p {\n  margin-bottom: 6px;\n}\n\n.wt-login-flow-notice p:last-child {\n  margin-bottom: 0;\n}\n\n.wt-login-flow-continuation {\n  color: #245269;\n  font-weight: 600;\n}\n\n.wt-login-session-option {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 14px;\n  padding: 0 2px;\n}\n\n.wt-login-session-option label {\n  margin: 0;\n  font-weight: 500;\n}\n\n.wt-login-session-option span {\n  color: #777;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.wt-auth-options-loading {\n  margin: 28px 0;\n  text-align: center;\n}\n\n.wt-email-auth-panel {\n  margin-bottom: 12px;\n}\n\n.wt-email-auth-panel .panel-body {\n  padding: 18px 20px 20px;\n}\n\n.wt-email-auth-panel .panel-body > .text-muted:first-child {\n  margin-bottom: 16px;\n}\n\n.wt-passkey-option {\n  margin: 12px 0;\n}\n\n.wt-passkey-option .help-block {\n  margin-bottom: 0;\n}\n\n.wt-password-toggle {\n  margin: 8px 0;\n  padding: 10px 12px;\n  border-top: 1px solid #e5e5e5;\n  border-bottom: 1px solid #e5e5e5;\n  border-radius: 0;\n}\n\n.wt-password-signin-panel {\n  padding: 14px 0 4px;\n}\n\n.wt-login-help-links {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 12px 0 0;\n}\n\n.wt-login-help-links .btn-link {\n  padding: 0;\n}\n\n.wt-recovery-signin-panel {\n  margin: 14px 0 0;\n}\n\n.wt-social-signin-section {\n  margin-top: 18px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e5e5;\n}\n\n.wt-social-signin-section .btn-group {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.wt-social-signin-section .btn {\n  flex: 1 0 auto;\n}\n\n.wt-login-utilities {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-top: 22px;\n  padding-top: 18px;\n  border-top: 1px solid #e5e5e5;\n  color: #666;\n  text-align: center;\n}\n\n.wt-access-message {\n  max-width: 540px;\n  margin: 32px auto;\n  text-align: center;\n}\n\n.wt-access-message .panel-body {\n  padding: 28px 24px;\n}\n\n.wt-access-message h2 {\n  margin: 8px 0 10px;\n  font-size: 26px;\n}\n\n.wt-access-message p {\n  margin-bottom: 18px;\n}\n\n.wt-access-message-icon {\n  color: #8a6d3b;\n  font-size: 28px;\n}\n\n.wt-auth-prompt-modal .modal-dialog {\n  margin-top: 80px;\n}\n\n.wt-auth-prompt-modal .modal-content {\n  overflow: hidden;\n  border: 0;\n  border-radius: 8px;\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.28);\n}\n\n.wt-auth-prompt-modal .modal-header {\n  padding: 20px 20px 12px;\n  border-bottom: 0;\n}\n\n.wt-auth-prompt-modal .modal-title {\n  padding-right: 28px;\n  color: #245269;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.wt-auth-prompt-modal .modal-body {\n  padding: 4px 20px 10px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.wt-auth-prompt-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 20px 20px;\n  border-top: 0;\n}\n\n.wt-auth-prompt-modal .modal-footer::before,\n.wt-auth-prompt-modal .modal-footer::after {\n  display: none;\n}\n\n.wt-auth-prompt-copy p:last-child {\n  margin-bottom: 0;\n}\n\n.wt-context-sidebar {\n  position: sticky;\n  top: 84px;\n  padding: 0 0 24px;\n}\n\n.list-group-item.wt-entry-row,\n.list-group.wt-list > .list-group-item.wt-entry-row,\n.wt-list .list-group > .list-group-item.wt-entry-row {\n  display: grid;\n  grid-template-columns: var(--wt-entry-row-icon-column) minmax(0, 1fr);\n  align-items: start;\n  column-gap: var(--wt-entry-row-column-gap);\n  padding-block: var(--wt-entry-row-padding-block);\n  padding-inline: var(--wt-entry-row-padding-inline-start) var(--wt-entry-row-padding-inline-end);\n  background-color: transparent;\n}\n\n.list-group-item.wt-entry-row > .wt-entry-row-icon {\n  position: static;\n  display: inline-flex;\n  grid-column: 1;\n  align-items: center;\n  justify-content: center;\n  width: var(--wt-entry-row-icon-column);\n  min-width: 0;\n  margin: 2px 0 0;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.list-group-item.wt-entry-row > .wt-entry-row-main,\n.list-group.wt-list > .list-group-item.wt-entry-row > .wt-entry-row-main,\n.wt-list .list-group > .list-group-item.wt-entry-row > .wt-entry-row-main {\n  grid-column: 2;\n  float: none;\n  min-width: 0;\n  width: auto;\n  margin-left: 0;\n}\n\n.wt-entry-row-title > .label,\n.wt-entry-row-title > a + .label {\n  margin-left: 6px;\n  vertical-align: 2px;\n}\n\n.wt-entry-row-title > .wt-screening-status {\n  display: inline-block;\n  margin-left: 6px;\n  color: #4cae4c;\n  font-size: 14px;\n  line-height: 1;\n  vertical-align: 1px;\n}\n\n.wt-entry-row-subtitle {\n  margin-bottom: 2px;\n  color: #777;\n  font-size: 12px;\n}\n\n.wt-entry-row-content {\n  max-width: 760px;\n  color: #4d4d4d;\n  line-height: 1.45;\n}\n\n.wt-entry-row-show-more,\n.wt-entry-child-count {\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font: inherit;\n  line-height: inherit;\n  vertical-align: baseline;\n}\n\n.wt-entry-row-show-more {\n  margin-left: 5px;\n}\n\n.wt-entry-child-count {\n  color: inherit;\n}\n\n.wt-entry-row-footer > .entry-options {\n  float: none !important;\n  margin: 0;\n}\n\n.wt-entry-row-footer > .entry-options > a {\n  display: inline-flex;\n  align-items: center;\n}\n\n.wt-entry-children {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 10px 18px;\n  margin-top: 10px;\n  padding: 10px 12px;\n  background: var(--wt-surface-muted);\n  border: 1px solid var(--wt-border);\n  border-radius: 4px;\n}\n\n.wt-entry-children-group h4 {\n  margin: 0 0 5px;\n  color: var(--wt-text);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.wt-entry-children-group ul,\n.wt-entry-children-group li:last-child {\n  margin-bottom: 0;\n}\n\n.wt-entry-children-group li {\n  margin-bottom: 3px;\n}\n\n.wt-entry-children-message {\n  margin-top: 8px;\n  padding: 8px 10px;\n  background: var(--wt-surface-muted);\n  border-radius: 4px;\n}\n\n.wt-entry-row-footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px 12px;\n  margin-top: 5px;\n  font-size: 12px;\n}\n\n.wt-entry-row-footer > a,\n.wt-entry-row-footer > span {\n  margin-right: 0 !important;\n  color: #777;\n}\n\n.wt-entry-row-media {\n  margin: 8px 0 5px;\n}\n\n.wt-entry-row-media .img-responsive {\n  max-width: 220px;\n  max-height: 220px;\n  border-radius: 2px;\n}\n\n.wt-deterministic-avatar {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border: 2px solid rgba(255, 255, 255, 0.75);\n  border-radius: 50%;\n  background-position: center;\n  background-size: cover;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.22);\n  color: #fff;\n  font-weight: 700;\n  line-height: 1;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);\n}\n\n.wt-profile-avatar {\n  margin-bottom: 8px;\n  font-size: 28px;\n}\n\n.navbar-nav > li > .wt-navbar-control {\n  display: block;\n  padding: 15px;\n  margin: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: #777;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: 20px;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.navbar-nav > li > .wt-navbar-control:hover,\n.navbar-nav > li > .wt-navbar-control:focus {\n  color: #333;\n  text-decoration: none;\n}\n\n.wt-user-menu-choice {\n  display: grid;\n  grid-template-columns: 16px minmax(0, 1fr);\n  gap: 8px;\n  width: 100%;\n  padding: 6px 20px;\n  color: var(--wt-text, #333);\n  text-align: left;\n  white-space: normal;\n}\n\n.wt-user-menu-choice:hover,\n.wt-user-menu-choice:focus {\n  color: var(--wt-text, #333);\n}\n\n.wt-user-menu-choice > i {\n  margin-top: 3px;\n  color: var(--wt-text-muted, #777);\n}\n\n.wt-user-menu-choice strong,\n.wt-user-menu-choice small {\n  display: block;\n}\n\n.wt-user-menu-choice strong {\n  color: var(--wt-text, #333);\n}\n\n.wt-user-menu-choice small {\n  margin-top: 1px;\n  color: var(--wt-text-muted, #777);\n  font-size: 11px;\n  line-height: 1.3;\n}\n\n.wt-content-view-summary {\n  min-height: 24px;\n  margin-bottom: 5px;\n  font-size: 12px;\n}\n\n.wt-content-view-summary .btn-link {\n  padding: 1px 0;\n}\n\n/* Keep keyboard location unmistakable without adding a ring to pointer clicks. */\na:focus-visible,\nbutton:focus-visible,\n[role='button']:focus-visible,\n.btn:focus-visible,\n.btn-link:focus-visible,\n.nav > li > a:focus-visible {\n  outline: 3px solid #0b6b9c !important;\n  outline-offset: 2px !important;\n  box-shadow: 0 0 0 2px #fff !important;\n}\n\n.wt-context-sidebar .wt-nav.nav {\n  margin: 0;\n  padding: 6px 0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.wt-context-sidebar .wt-nav .dropdown-header {\n  padding: 8px 12px;\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.wt-context-sidebar .wt-nav > li > a {\n  display: block;\n  padding: 6px 12px;\n}\n\n.wt-context-sidebar .wt-nav > li > a.wt-context-sidebar-link {\n  display: grid;\n  grid-template-columns: 20px minmax(0, 1fr) auto;\n  align-items: start;\n  column-gap: 8px;\n  min-height: 36px;\n  padding: 7px 12px;\n}\n\n.wt-context-sidebar .wt-context-sidebar-link > i,\n.wt-context-sidebar .wt-context-sidebar-link > img {\n  margin: 2px 0 0;\n  text-align: center;\n}\n\n.wt-context-sidebar .wt-context-sidebar-label {\n  min-width: 0;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.wt-context-sidebar .wt-context-sidebar-badge {\n  align-self: start;\n  justify-self: end;\n  min-width: 26px;\n  margin: 0 0 0 10px;\n  padding: 4px 6px;\n  border: 1px solid #cbd6e0;\n  border-radius: 5px;\n  color: #46596c;\n  background: #e8eef4;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  text-align: center;\n}\n\n.wt-popover {\n  position: relative;\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.wt-popover .wt-popover-content {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 20;\n  display: none;\n  min-width: 180px;\n  margin-top: 8px;\n  padding: 8px 10px;\n  border: 1px solid var(--wt-border);\n  border-radius: 4px;\n  background: var(--wt-surface);\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.15);\n}\n\n.wt-popover:hover .wt-popover-content,\n.wt-popover:focus-within .wt-popover-content {\n  display: block;\n}\n\n.vis-container {\n  position: relative;\n}\n\n.vis-container.fullscreen {\n  z-index: 10000;\n  position: fixed;\n  inset: 0;\n  padding: 12px;\n  background: rgba(255, 255, 255, 0.98);\n  overflow: auto;\n}\n\n.wt-viz-btn-cont {\n  position: absolute;\n  z-index: 100;\n}\n\n.wt-viz-btn-cont .wt-viz-btn {\n  background-color: #00b0b9;\n  padding: 3px 5px;\n  border-radius: 3px;\n  margin: 5px;\n  display: inline-block;\n}\n\n.wt-viz-btn-cont .wt-viz-btn .btn.btn-link {\n  padding: 0;\n}\n\n.page-header.wt-header.wt-profile-header {\n  background-image: linear-gradient(-110deg, #48227d 0%, #2f569c 100%);\n  color: #fff;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n/* Tighten entry-page spacing between geo-pattern bar and main header. */\n.wt-geo-pattern + .page-header.wt-header:not(.wt-profile-header) {\n  margin-top: 16px;\n}\n\n@media (max-width: 991px) {\n  .wt-entry-header .pull-left,\n  .wt-entry-header .pull-right {\n    float: none !important;\n    display: block;\n  }\n}\n\n@media (max-width: 767px) {\n  body {\n    padding-top: 50px;\n  }\n\n  .wt-primary-navigation .wt-header-more-menu {\n    position: fixed;\n    top: 50px;\n    right: 8px;\n    left: auto;\n    width: min(280px, calc(100vw - 24px));\n    max-height: calc(100vh - 58px);\n    max-height: calc(100dvh - 58px);\n    overflow-y: auto;\n  }\n\n  .breadcrumb.wt-bc {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    overflow-x: visible;\n    white-space: normal;\n  }\n\n  .breadcrumb.wt-bc > li {\n    min-width: 0;\n    max-width: 100%;\n    overflow-wrap: anywhere;\n    white-space: normal;\n  }\n\n  .wt-access-message {\n    margin: 20px 5px;\n  }\n\n  .wt-login-flow-notice {\n    padding: 13px 14px;\n  }\n\n  .wt-login-container {\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n  .wt-login-header {\n    margin-top: 28px;\n  }\n\n  .wt-login-header h1 {\n    font-size: 34px;\n  }\n\n  .wt-login-session-option {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .wt-login-session-option span {\n    padding-left: 20px;\n  }\n\n  .wt-email-auth-panel .panel-body {\n    padding: 16px;\n  }\n\n  .wt-login-page .btn-block {\n    min-height: 44px;\n  }\n\n  .wt-auth-prompt-modal .modal-dialog {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: auto;\n    margin: 0;\n    transform: none !important;\n  }\n\n  .wt-auth-prompt-modal .modal-content {\n    padding-bottom: env(safe-area-inset-bottom);\n    border-radius: 14px 14px 0 0;\n  }\n\n  .wt-auth-prompt-modal .modal-header {\n    padding-top: 22px;\n  }\n\n  .wt-auth-prompt-modal .modal-footer {\n    padding-bottom: 18px;\n  }\n\n  .wt-auth-prompt-modal .modal-footer .btn {\n    min-height: 44px;\n  }\n\n}\n\n/* Match the legacy xxs utility: retain the wordmark on larger phones/tablets. */\n@media (max-width: 479px) {\n  .navbar-brand-label .hidden-xxs {\n    display: none !important;\n  }\n\n  .footer .copyright {\n    display: block;\n    float: none !important;\n    margin-top: 0;\n    text-align: center;\n  }\n\n  .footer .links {\n    text-align: center;\n  }\n\n  .wt-standard-footer-inner {\n    flex-direction: column;\n    justify-content: center;\n    gap: 12px;\n    padding-top: 14px;\n    padding-bottom: 14px;\n  }\n}\n\n.wt-explore-page-header {\n  position: relative;\n}\n\n.wt-explore-page #browse {\n  scroll-margin-top: 70px;\n}\n\n.wt-explore-header-actions {\n  padding: 8px 0;\n  font-size: 28px;\n  line-height: 1;\n}\n\n.wt-explore-header-actions > a {\n  color: #767676;\n  text-decoration: none;\n}\n\n.wt-explore-header-actions > a + a {\n  margin-left: 15px;\n}\n\n.wt-explore-filter-toggle {\n  margin-bottom: 10px;\n}\n\n.wt-explore-filter-toggle .badge {\n  margin-left: 6px;\n}\n\n.wt-explore-page .media.wt-category .media-body > div span,\n.wt-explore-page .media.wt-category .media-body > div a {\n  color: var(--wt-text-muted);\n}\n\n.wt-explore-page .wt-category-icon {\n  border: 1px solid var(--wt-border);\n}\n\n.wt-explore-page .media.wt-category .media-body > div a.wt-category-all-link {\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  margin-top: 2px;\n  color: var(--wt-brand-primary);\n  font-weight: 600;\n  gap: 4px;\n}\n\n.wt-explore-controls {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  margin-bottom: 15px;\n}\n\n.wt-explore-controls .btn-group {\n  margin-bottom: 0;\n}\n\n.wt-explore-page .nav.nav-tabs.wt-tabs {\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  align-items: stretch;\n  gap: 4px;\n  margin-right: 0;\n  margin-left: 0;\n  padding: 4px;\n  border: 1px solid var(--wt-border);\n  border-radius: 4px;\n  background-color: var(--wt-surface-muted);\n  scrollbar-width: thin;\n}\n\n.wt-explore-page .nav.nav-tabs.wt-tabs::before,\n.wt-explore-page .nav.nav-tabs.wt-tabs::after {\n  display: none;\n}\n\n.wt-explore-page .nav.nav-tabs.wt-tabs > li {\n  float: none;\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.wt-explore-page .nav.nav-tabs.wt-tabs > li > a,\n.wt-explore-page .nav.nav-tabs.wt-tabs > li.active > a {\n  display: flex;\n  align-items: center;\n  min-height: 42px;\n  margin: 0;\n  padding: 9px 12px;\n  border-bottom: 3px solid transparent;\n  color: var(--wt-text-muted);\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.wt-explore-page .nav.nav-tabs.wt-tabs > li.active > a,\n.wt-explore-page .nav.nav-tabs.wt-tabs > li.active > a:hover,\n.wt-explore-page .nav.nav-tabs.wt-tabs > li.active > a:focus {\n  border-bottom-color: #d26911;\n  color: var(--wt-text);\n  background-color: var(--wt-surface);\n}\n\n.wt-explore-results .list-group.wt-list {\n  overflow: hidden;\n  border-radius: 4px;\n}\n\n.wt-explore-results .list-group.wt-list .highlight {\n  display: flex;\n  align-items: center;\n  min-height: 44px;\n  margin-bottom: 5px;\n  padding: 10px 14px 8px;\n  border-color: var(--wt-border);\n  color: var(--wt-text);\n  gap: 10px;\n}\n\n.wt-explore-results .list-group.wt-list .highlight > .fa,\n.wt-explore-results .list-group.wt-list .highlight > .glyphicon {\n  position: static;\n  flex: 0 0 auto;\n  color: var(--wt-text-muted);\n}\n\n.wt-explore-results .list-group.wt-list .highlight > div {\n  float: none;\n  margin-left: 0;\n}\n\n.wt-explore-results .list-group.wt-list .wt-entry-row {\n  margin-bottom: 0;\n  border: 0;\n  border-bottom: 1px solid var(--wt-border);\n}\n\n.wt-explore-results .wt-entry-row-subtitle,\n.wt-explore-results .wt-entry-row-footer > a,\n.wt-explore-results .wt-entry-row-footer > span {\n  color: var(--wt-text-muted);\n}\n\n.wt-explore-results .wt-entry-row-footer .fa {\n  color: inherit;\n}\n\n@media (max-width: 767px) {\n  .wt-explore-controls {\n    display: block;\n  }\n\n  .wt-explore-controls > .btn-group {\n    margin-bottom: 8px;\n  }\n\n  .wt-explore-controls .wt-content-view-filter {\n    display: flex;\n    overflow-x: auto;\n    max-width: 100%;\n    scrollbar-width: none;\n  }\n\n  .wt-explore-controls .wt-content-view-filter::-webkit-scrollbar {\n    display: none;\n  }\n\n  .wt-explore-controls .wt-content-view-filter > .btn {\n    float: none;\n    flex: 0 0 auto;\n  }\n\n  .wt-explore-advanced-filters {\n    display: none;\n  }\n\n  .wt-explore-advanced-filters.is-open {\n    display: block;\n  }\n\n  .wt-explore-page .nav.nav-tabs.wt-tabs {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n\n/* Search result keyboard navigation */\n.wt-result-focused {\n  background-color: #f0f6ff;\n  outline: 2px solid #337ab7;\n  outline-offset: -2px;\n}\n\n[data-theme='dark'] .wt-result-focused {\n  background-color: #1a2a3a;\n  outline-color: #5ba3d9;\n}\n\n.wt-reputation-card {\n  border-top: 3px solid #2f7d68;\n}\n\n.wt-reputation-score {\n  width: 92px;\n  height: 92px;\n  margin: 0 auto 8px;\n  border: 8px solid #d9eee8;\n  border-radius: 50%;\n  color: #1f6655;\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 76px;\n}\n\n.wt-reputation-dimension .progress {\n  height: 8px;\n  margin: 3px 0 10px;\n  background: #edf2f0;\n}\n\n.wt-reputation-dimension .progress-bar {\n  background: linear-gradient(90deg, #2f7d68, #56a37f);\n}\n\n.wt-pin-inputs {\n  display: flex;\n  gap: 10px;\n}\n\n.wt-pin-inputs .pincode-input-text {\n  width: 55px;\n  text-align: center;\n}\n\n.wt-code-wrap {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n@media (max-width: 767px) {\n  .wt-topic-selector {\n    width: 100%;\n  }\n\n  .wt-topic-selector .wt-topic-selector-button {\n    max-width: 100%;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    text-align: left;\n  }\n\n  .wt-outline-tree-button {\n    display: inline-flex;\n    max-width: 100%;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    text-align: left;\n  }\n\n  .wt-outline-tree-button .fa {\n    flex: 0 0 auto;\n    margin-top: 2px;\n  }\n\n  .wt-pin-inputs {\n    display: grid;\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    gap: 6px;\n  }\n\n  .wt-pin-inputs .pincode-input-text {\n    width: 100%;\n    min-width: 0;\n    padding-right: 4px;\n    padding-left: 4px;\n  }\n}\n\n.wt-reputation-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.wt-reputation-badges .label {\n  display: inline-block;\n  padding: 6px 9px;\n}\n\n.wt-entry-lifecycle-notice {\n  margin-bottom: 14px;\n  border-left-width: 4px;\n}\n\n.wt-entry-lifecycle-stack {\n  margin: 12px 0 16px;\n}\n\n.wt-entry-lifecycle-stack .wt-entry-lifecycle-notice:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
